import React, { useState } from 'react';
import pakaiClass from 'pakai-class';
import { FileDownload } from '../../assets/icons';
import styles from './templates.module.scss';

const FileCard = ({ filename, url, className, title, size = 'medium' }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async (e) => {
    e.preventDefault();
    setIsDownloading(true);
    
    try {
      // Add a small delay to show the downloading state
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Create a temporary link for download
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
      window.open(url, '_blank');
    } finally {
      setIsDownloading(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div 
      className={pakaiClass(
        styles.fileCard, 
        styles.modern,
        styles[size],
        isHovered && styles.hovered,
        className
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={styles.cardContent}>
        <div className={styles.fileIcon}>
          <div className={styles.iconWrapper}>
            <i className="fas fa-file-pdf"></i>
            <div className={styles.iconGlow}></div>
          </div>
          <div className={styles.fileType}>PDF</div>
        </div>
        
        <div className={styles.fileInfo}>
          <h6 className={styles.fileTitle}>{title}</h6>
          <p className={styles.fileName}>{filename}</p>
          {size && (
            <span className={styles.fileSize}>
              {typeof size === 'number' ? formatFileSize(size) : 'Ready to download'}
            </span>
          )}
        </div>
      </div>

      <div className={styles.fileActions}>
        <button 
          className={pakaiClass(
            styles.downloadBtn,
            isDownloading && styles.downloading
          )}
          onClick={handleDownload}
          disabled={isDownloading}
          title={isDownloading ? "Downloading..." : "Download file"}
        >
          <div className={styles.btnContent}>
            {isDownloading ? (
              <>
                <div className={styles.spinner}></div>
                <span>Downloading...</span>
              </>
            ) : (
              <>
                <FileDownload size="14" />
                <span>Download</span>
              </>
            )}
          </div>
        </button>
      </div>

      <div className={styles.cardOverlay}></div>
    </div>
  );
};

export default FileCard;
